var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortText = function SvgShortText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.67 23.478a1 1 0 0 1 1 1v7.089h6.972a1 1 0 1 1 0 2H40.67v18.656c0 1.159 1.041 2.154 2.69 2.286 1.563.126 3.377-.614 4.326-2.7a1 1 0 0 1 1.82.828c-1.327 2.917-3.976 4.053-6.306 3.866-2.246-.18-4.53-1.687-4.53-4.28V33.567h-6.312a1 1 0 0 1 0-2h6.312v-7.09a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.395 10.688a1 1 0 0 1 1-1h58a1 1 0 0 1 1 1v58a1 1 0 0 1-1 1h-58a1 1 0 0 1-1-1zm2 1v56h56v-56z",
    clipRule: "evenodd"
  })));
};
export default SvgShortText;